module.exports = __webpack_public_path__ + "img/5-1.99b9d785.png";